// QUERY are user function expressions used to generate CHAIN

const gaqlenumTYPE = 'gn:type'
const gaqlenumLAZY = 'gn:LAZY'
const gaqlenumMODE = 'gn:MODE'
const gaqlenumQUERY = 'gn:QUERY'
const gaqlenumCHAIN = 'gn:CHAIN'
const gaqlenumERROR = 'gn:ERROR'
const gaqlenumARGSIG = 'gn:ARGSIG'
const gaqlenumARGRES = 'gn:ARGRES'

const gaqlenumSORTBY = 'sortBy'
const gaqlenumSORTDIRECTION = 'sortDirection'
const gaqlenumSORTORDERDESC = 'desc'
const gaqlenumSORTORDERASC = 'asc'

const gaqlenumQueryNameBRACKET = 'bracket'
const gaqlenumQueryNameDEFAULT = 'default'
const gaqlenumQueryNameGETFIELD = 'getField'
const gaqlenumQueryNameROW = 'row'
const gaqlenumQueryNameRUN = 'run'
const gaqlenumQueryNameOPTS = 'opts'

const gaqlenumMODERETURN = 'return'
const gaqlenumMODELIST = 'list'
const gaqlenumMODEJOIN = 'join'

// hide queries and config state on prototype of object
// reducing noise on the object when printed to console.
//
// not fully working at this time and could be removed later
const gaqlenumCFGISPROTOQUERY = true

export {
  gaqlenumTYPE,
  gaqlenumLAZY,
  gaqlenumMODE,
  gaqlenumQUERY,
  gaqlenumCHAIN,
  gaqlenumERROR,
  gaqlenumARGSIG,
  gaqlenumARGRES,

  gaqlenumSORTBY,
  gaqlenumSORTDIRECTION,
  gaqlenumSORTORDERDESC,
  gaqlenumSORTORDERASC,

  gaqlenumMODERETURN,
  gaqlenumMODELIST,
  gaqlenumMODEJOIN,

  gaqlenumQueryNameBRACKET,
  gaqlenumQueryNameDEFAULT,
  gaqlenumQueryNameGETFIELD,
  gaqlenumQueryNameOPTS,
  gaqlenumQueryNameROW,
  gaqlenumQueryNameRUN,

  gaqlenumCFGISPROTOQUERY
}
